import auth from '../authentication';
import Vue from '../main';

export default {
    getFeedback(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/feedback/get-all', data)
            .then(response => {
                context.error = false;
                context.feedback = response.data.data;
                context.total = response.data.total;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },
    getAll(data) {
        return Vue.http.post(Vue.apiUrl + '/feedback/all', data);
    },
};